import employees from "@/assets/employees.svg";
import addemployees from "@/assets/addemployees.svg";
import boldx from "@/assets/boldx.svg";
import downarrow from "@/assets/downarrow.svg";
import arrowDownToLine from "@/assets/arrow-down-to-line.svg";
import calendar from "@/assets/calendar.svg";
import largecompliantcheck from "@/assets/LargeCompliantCheck.svg";
import largenoncompliantx from "@/assets/LargeNonCompliantX.svg";
import engagelogo from "@/assets/EngageLogo.svg";
import creditcard from "@/assets/CreditCard.svg";
import bankaccount from "@/assets/BankAccount.svg";
import myAccount from "@/assets/my-account.svg";
import account from "@/assets/Account.svg";
import dashboard from "@/assets/dashboard.svg";
import myCustomers from "@/assets/my-customers.svg";
import population from "@/assets/population.svg";
import reports from "@/assets/reports.svg";
import reportsLarge from "@/assets/ReportsLarge.svg";
import valid from "@/assets/Filled.svg";
import initial from "@/assets/NotFilled.svg";
import error from "@/assets/error.svg";
import warning from "@/assets/warning.svg";
import customerClipboard from "@/assets/customer-clipboard.svg";
import home from "@/assets/Home.svg";
import allCaughtUp from "@/assets/AllCaughtUp.svg";
import goodStanding from "@/assets/GoodStanding.svg";
import needsAttention from "@/assets/NeedsAttention.svg";
import ribbon from "@/assets/ribbon.svg";
import celebrationsAndEncouragement from "@/assets/CelebrationsAndEncouragement.svg";
import fullyAutomatedMonitoring from "@/assets/FullyAutomatedMonitoring.svg";
import form from "@/assets/Form.svg";
import upload from "@/assets/Upload.svg";
import info from "@/assets/Info.svg";
import employeeUploadSuccess from "@/assets/EmployeeUploadSuccess.svg";
import vpLogo from "@/assets/vplogo.svg";
import fileLines from "@/assets/file-lines.svg";
import calendarIcon from "@/assets/CalendarIcon.svg";
import peopleIcon from "@/assets/PeopleIcon.svg";
import uploadIcon from "@/assets/UploadIcon.svg";

export const svgIconAssets = {
  employees,
  addemployees,
  boldx,
  downarrow,
  arrowDownToLine,
  calendar,
  largecompliantcheck,
  largenoncompliantx,
  engagelogo,
  creditcard,
  bankaccount,
  myAccount,
  account,
  dashboard,
  myCustomers,
  population,
  reports,
  reportsLarge,
  valid,
  initial,
  error,
  warning,
  customerClipboard,
  home,
  allCaughtUp,
  goodStanding,
  needsAttention,
  celebrationsAndEncouragement,
  fullyAutomatedMonitoring,
  form,
  upload,
  info,
  employeeUploadSuccess,
  ribbon,
  vpLogo,
  fileLines,
  calendarIcon,
  peopleIcon,
  uploadIcon
};

export const svgIconNames = Object.keys(svgIconAssets);
